import React, { FC } from 'react'
import { IonModal, IonContent, IonHeader, IonFooter } from '@ionic/react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { MktButton, Icon } from '@cps'
import './index.scss'

interface IProps {
  show: boolean;
  title: string;
  hasFooter?: boolean;
  btnText?: string;
  className?: string;
  onClose: () => any;
  onSave?: () => any;
}
interface IState {
}

const MktModal: FC<IProps> = (props) => {
  const {
    show,
    title,
    hasFooter = true,
    btnText = i18n.t('mkt.common.confirm'),
    className,
    onClose,
    onSave
  } = props
  const initialState: IState = {
  }
  const handleClose = () => {
    onClose && onClose()
  }
  const handleSave = () => {
    onSave && onSave()
  }
  return (
    <IonModal
      isOpen={show}
      cssClass={className ? 'mkt-modal ' + className : 'mkt-modal'}
      showBackdrop
      swipeToClose
      backdropDismiss
      onDidDismiss={handleClose}
    >
      <IonHeader className='modal-header'>
        <h3 className='title'>{title}</h3>
        <Icon name='close' data-cypid='mktModalClose' onClick={handleClose} />
      </IonHeader>
      <IonContent>
        <div className='modal-content'>{props.children}</div>
        {
          hasFooter && (
            <IonFooter className='modal-footer'>
              <MktButton text={btnText} data-cypid='mktModalConfirm' onClick={handleSave} />
            </IonFooter>
          )
        }
      </IonContent>
    </IonModal>
  )
}

export default observer(MktModal)
